import React, { useContext, useEffect, useState } from 'react'
import Sidebar from '../StudentSidebar/Sidebar'
import { CartContext } from '../CartContext';
import StudentNavbar from '../StudentNavbar/StudentNavbar'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PngImages } from '../../Utils/LocalImages'
import RoutesPath from '../../Utils/RoutesPath';
import { Button, Modal } from 'react-bootstrap';
import Image from '../../Components/Reusable/Image';
import CustomTextFieldTwo from '../../Components/Reusable/CustomTextFieldTwo';
import { yupResolver } from '@hookform/resolvers/yup';
import { handleApiErrors, InputType, validationRegex } from '../../Utils/Utils';
import * as yup from "yup";
import { useForm } from 'react-hook-form';
import axios from 'axios';
import { toast } from 'react-toastify';
import StudentDashboardServices from '../../Services/StudentDashboardApiService';
import { AuthContext } from '../../Context/authContext';
import ApiConstants from '../../Utils/ApiConstant';
import { RotatingLines } from 'react-loader-spinner';

let cartCount = ""
const Checkout = () => {
    const location = useLocation();
    const refferalState = location.state || {}
    const couponCode = location.state || {}
    const { user, updateUserCartCount } = useContext(AuthContext);
    const [showModal, setShowModal] = useState(false);
    const [showModalReject, setShowModalReject] = useState(false);
    const [termsChecked, setTermsChecked] = useState(false);
    const [cartData, setCartData] = useState([]);
    const [refferalcode, setRefferalCode] = useState({});
    const [coupon, setCoupon] = useState({});
    const [cartSummary, setCartSummary] = useState({});
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate()
    const handleClose = () => { setShowModalReject(false), navigate(RoutesPath.checkout) };

    const Validations = yup.object().shape({
        // referralcode: validationRegex.required,
    });

    const {
        register,
        handleSubmit,
        setValue: setValues,
        formState: { errors },
        getValues,
        reset,
    } = useForm({
        resolver: yupResolver(Validations),
        defaultValues: {
            referralcode: "",
        },
    });


    // const ApplyRefferal = async () => {
    //     const referralcode = getValues('referralcode');
    //     try {
    //         const response = await StudentDashboardServices.checkReferralCode(referralcode);
    //         if (response.status === 200) {
    //             setRefferalCode(response.data.coordinator);
    //             toast.success("Refferal Code Applied");
    //             reset();
    //         } else {
    //             setRefferalCode({})
    //             reset();
    //         }
    //     } catch (error) {
    //         handleApiErrors(error);
    //         setRefferalCode({})
    //     }
    // }


    const getAllCart = async () => {
        try {
            const response = await StudentDashboardServices.getAllCart();
            setCartData(response.cartList || []);
            setCartSummary(response.summary || {});
            cartCount = response.cartCount
            updateUserCartCount(cartCount);
            setRefferalCode(refferalState.refferalcode)
        } catch (error) {
            handleApiErrors(error);
        }
    };

    useEffect(() => {
        setCoupon(couponCode.couponCode)
        getAllCart();
        console.log(refferalcode, 'refferalcode')
        console.log(coupon, 'coupon')

    }, [cartCount, refferalcode, couponCode]);

    const handleShow = async () => {
        if (!termsChecked) {
            toast.error('Please agree to the Terms of Service before proceeding.');
            return;
        }
        if (!window.Razorpay) {
            console.error('Razorpay script not loaded');
            toast.error('Payment gateway not available.');
            return;
        }
        setLoading(true);
        const timeoutId = setTimeout(() => {
            setLoading(false);
        }, 5000);
        try {

            // Step 1: Create an order
            const orderResponse = await StudentDashboardServices.createOrder(

                refferalcode.referralCode || "",
                coupon.couponId || "",
                refferalcode.referralCode ? refferalcode.referralCode ? cartSummary.grandTotalCoordinator : cartSummary.grandTotal : coupon.grandTotal ? coupon.grandTotal : cartSummary.grandTotal,
                'INR'
            );

            if (orderResponse.message === "Payment Verified Successfully") {
                setLoading(false);
                clearTimeout(timeoutId);
                toast.success(orderResponse.packageNames + " " + 'Payment Verified Successfully!');
                getAllCart();
                setShowModal(true);
                return;
            }

            const actualPriceInt = Math.floor(cartSummary.grandTotal);
            const discountCoordinatorInt = Math.floor(cartSummary.grandTotalCoordinator);

            if (actualPriceInt < 1) {
                setLoading(false);
                clearTimeout(timeoutId);
                toast.success('Payment Successful!');
                getAllCart();
                setShowModal(true);
            } else {
                const { id, currency, amount, notes } = orderResponse;
                console.log(orderResponse, 'orderResponse');
                // Step 2: Initialize Razorpay
                const options = {
                    key: process.env.REACT_APP_RAZORPAY_KEY,
                    amount: amount,
                    currency: currency,
                    name: "Learn & Achieve",
                    // description: orderResponse.notes,
                    order_id: id,
                    handler: async (response) => {
                        toast.success('Payment Successful!');
                        getAllCart();
                        setShowModal(true);
                        // try {
                        //     // Step 3: Verify payment
                        //     const paymentResponse = await StudentDashboardServices.packagePurchase(
                        //         razorpay_order_id,
                        //         razorpay_payment_id,
                        //         razorpay_signature,
                        //         refferalcode.referralCode

                        //     );

                        //     // Optional: Call the webhook verification endpoint (if needed)

                        //     // const webhookResponse = await StudentDashboardServices.verifyPaymentWebhook(
                        //     //     razorpay_signature
                        //     // );

                        //     // console.log('Webhook verification response:', webhookResponse);
                        //     if (paymentResponse.message === "Payment Verified Successfully") {
                        //         toast.success('Payment Successful!');
                        //         getAllCart();
                        //         setShowModal(true);
                        //     } else {
                        //         throw new Error('Payment verification failed.');
                        //     }
                        // } catch (error) {
                        //     console.error('Error verifying payment', error);
                        //     toast.error('Payment verification failed. Please try again.');
                        //     setLoading(false);
                        //     clearTimeout(timeoutId);
                        //     setShowModalReject(true);
                        // }
                    },
                    prefill: {
                        name: user.firstName,
                        email: user.email,
                        contact: user.mobile,
                    },
                    theme: {
                        color: '#F6821F'
                    }
                };
                const paymentObject = new window.Razorpay(options);
                paymentObject.open();
            }
        } catch (error) {
            console.error('Error creating order', error);
            toast.error('Something went wrong. Please try again.');
            setLoading(false);
            clearTimeout(timeoutId);
            // setShowModalReject(true);
        }
    };
    return (
        <div className="d-flex">
            <Sidebar />
            <div className="mainLayout-content">
                <StudentNavbar />
                <div className="main_content contentSection scroll_bar">
                    <div className="mb-4 d-flex justify-content-between align-items-center">
                        <h1 className="black sub-large-text-one fw-700 mb-0">Checkout</h1>
                        <Link to={RoutesPath.addtocart}>
                            <div className="d-flex" style={{ paddingRight: "10px" }}>
                                <h4 className="Caption fw-600  mb-0"><span className='orangeAccentColor'>Back</span> &gt;</h4>
                            </div>
                        </Link>
                    </div>
                    <div className="my-3 row">
                        <div className='col-xxl-9 col-lg-7 col-md-12 col-sm-12 '>

                            {cartData.map(item => (

                                < div key={item.cart_id} className="cart-item respo-item row me-3 py-4 hrline2" >
                                    <div className='col-lg-3 col-md-6 col-sm-6 col-xs-6 addtocardimagesizecart pb-2'>
                                        <Image className="card-img-top addtocartimage" src={item?.mainImage && item.mainImage?.trim() !== "" ? ApiConstants.FILE_FETCH_URL + item.mainImage : ""} alt='' />
                                    </div>
                                    <div className='col-lg-9 col-md-6 col-sm-6 col-xs-6 justify-content-between d-flex  text-start respo-cont '>
                                        <div className=' py-2  '>
                                            <div className='medium-text fw-700 text-dark py-2'>{item.packageName}</div>
                                            {/* <p>Price: ₹{item.price}</p> */}
                                            <div className="d-flex gap-2">
                                                <span className="disprice sub-large-text  fw-700">₹{item.discountedPrice}</span>
                                                <div className="originalprice small-text fw-400 pb-1">₹{item.actualPrice}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {/* <div className="row my-4 d-flex align-items-center">
                                <div className='small-medium-text fw-700 py-2'>Referral Code</div>
                                <div className="col-md-8 text-muted">
                                    <CustomTextFieldTwo
                                        // labelTitle=""
                                        placeholder="Enter referral code"
                                        name="referralcode"
                                        additionalClasses="profile_edit"
                                        id="referralcode"
                                        labelClass="TextInput"
                                        inputType={InputType.text}
                                        // showMandatory={true}
                                        register={register}
                                        setValue={setValues}
                                        showError={errors?.referralcode}
                                        errorMessage={errors?.referralcode?.message}
                                    />
                                </div>
                                <div className="col-md-4 small-text fw-500 pb-2">
                                    <Button className=" justify-content-center text-center border-0 w-50 py-2" variant="primary" style={{ backgroundColor: '#14489F' }}
                                        onClick={() => ApplyRefferal({})}
                                    >Apply</Button>
                                </div>
                            </div> */}

                        </div>
                        <div className='col-xxl-3 col-lg-5 col-md-12 col-sm-12  mt-4 '>
                            <div className='p-5 align-items-center align-self-top' style={{ backgroundColor: '#f3f5f6', borderRadius: "20px" }}>
                                <p className='sub-large-text fw-700' style={{ color: '#14489F' }} >Summary</p>
                                <div className='hrline2 text-dark'>
                                    <div className='justify-content-between d-flex py-3 small-medium-text fw-500 '>
                                        <div className=''>Subtotal:</div>
                                        <div className='fw-500'>₹{cartSummary.subTotal}</div>
                                    </div>
                                    {refferalcode.referralCode && <div className='justify-content-between d-flex  py-3 small-medium-text fw-500'>
                                        <div className=''>Discount:</div>
                                        <div className='text-success fw-500'>-₹ {cartSummary.discountAmt}</div>
                                    </div>}
                                    {coupon.discountAmount && <div className='justify-content-between d-flex  py-3 small-medium-text fw-500'>
                                        <div className=''>Discount:</div>
                                        <div className='text-success fw-500'>-₹ {coupon.discountAmount}</div>
                                    </div>
                                    }

                                    {/* {
                                        refferalcode.referralCode ?
                                            <div className='justify-content-between d-flex  py-3 small-medium-text fw-500'>
                                                <div className=''>Refferal Discount:</div>
                                                <div className='text-success fw-500'>-₹{cartSummary.totalReferralDiscountAmt}</div>
                                            </div> : null
                                    } */}

                                </div>

                                {!coupon.discountAmount && <div className='justify-content-between d-flex fw-600 small-medium-text py-3 mb-5'>
                                    <div className=''>Total Amount:</div>
                                    <div className=''>₹{refferalcode.referralCode ? cartSummary.grandTotalCoordinator : cartSummary.grandTotal}</div>
                                </div>}
                                {coupon.discountAmount && <div className='justify-content-between d-flex fw-600 small-medium-text py-3 mb-5'>
                                    <div className=''>Total Amount:</div>
                                    <div className=''>₹{coupon.grandTotal}</div>
                                </div>}
                                <div className=' form-check fw-600 small-medium-text py-3 '>
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="flexCheckChecked"
                                        checked={termsChecked}
                                        onChange={(e) => setTermsChecked(e.target.checked)}
                                    />
                                    <label className="form-check-label small-medium-text" for="flexCheckChecked">
                                        <div className=' fw-400 '>By completing your purchase you agree to these <br /> <span onClick={() => navigate(RoutesPath.termsAndConditions)} className='fw-600 cursor-pointer' style={{ color: '#14489F' }}>Terms of Service.</span> </div>
                                    </label>
                                </div>

                                <div className='pt-3 checkoutbtn'>
                                    {loading ? (
                                        <div className="text-center d-flex justify-content-center">
                                            <RotatingLines
                                                height="25"
                                                width="25"
                                                strokeColor="#F6821F"
                                                ariaLabel="bars-loading"
                                                wrapperStyle={{}}
                                                wrapperClass=""
                                            />
                                        </div>
                                    ) : (
                                        <Button className="addtocardbtn Blogtexting Sub-Heading fw-600 w-100 justify-content-center text-center border-0 py-2" style={{ borderRadius: "10px", backgroundColor: "#F6821F" }} onClick={handleShow}>
                                            Proceed to Pay
                                        </Button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* SuccessModel */}
            <Modal show={showModal} fullscreen={true} centered backdrop="static" keyboard={false}>
                <Modal.Body className='d-flex flex-column align-items-center justify-content-center'>
                    <div className="d-inline-block">
                        <Image src={PngImages.payment_success} alt='' className="w-100" />
                    </div>
                    <p className='Small-Heading fw-700' style={{ color: "#368C36" }}>Payment Successful!</p>
                    <div className='sub-large-text-one fw-500 pb-2'>Order Confirmed! Thank You for shopping with us.</div>
                    <div className='sub-large-text-one fw-500'>Have a Great Day!</div>

                    <div className='col-md-12 justify-content-center text-center border-0 mt-4'>
                        <Link to={RoutesPath.dashboardstudent}>
                            <Button className="addtocardbtn Sub-Heading fw-600 px-5 border-0 py-2" variant="primary" style={{ borderRadius: "10px", backgroundColor: "#F6821F" }}>
                                Go To Dashboard
                            </Button>
                        </Link>
                    </div>
                </Modal.Body>
            </Modal>
            {/* Failed-modal */}

            <Modal show={showModalReject}
                fullscreen={true} centered backdrop="static" keyboard={false}>
                <Modal.Body className='d-flex flex-column align-items-center justify-content-center'>
                    <div className="d-inline-block">
                        <Image src={PngImages.payment_fail} alt='' className="w-100" />

                    </div>
                    <p className='Small-Heading fw-700' style={{ color: "#FF3535" }}>Payment Failed!</p>
                    <div className='sub-large-text-one fw-500 pb-2'>Oops! Something went wrong. Please try again or contact support </div>
                    <div className='sub-large-text-one fw-500'><a href="support@learnandachieve.in">support@learnandachieve.in</a></div>

                    <div className='col-md-12 justify-content-center text-center border-0 mt-4'>
                        <Button className="addtocardbtn  Sub-Heading fw-600 px-5  border-0 py-2" variant="primary" onClick={handleClose} style={{ borderRadius: "10px", backgroundColor: "#F6821F" }}>
                            Retry Payment
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    )
}

export default Checkout

